<template>
  <div :class="`w-full rounded-md overflow-hidden ${background}`">
    <!-- Single clickable header that stays part of the same container -->
    <div
      @click="toggle"
      tabindex="0"
      role="button"
      :class="`flex w-full items-center justify-between px-3.5 py-2.5 text-slate-700 border-b border-indigo-900 transition-colors cursor-pointer ${style}`"
    >
      <div class="flex items-center gap-2.5">
        <!-- Step number -->
        <span class="text-sm font-medium text-slate-700">
          {{ step }}
        </span>

        <!-- Emoji icon -->
        <span class="text-lg leading-none">
          {{ icon }}
        </span>

        <!-- Title -->
        <span class="text-sm font-medium tracking-tight">
          {{ title }}
        </span>
      </div>

      <!-- Chevron -->
      <svg
        class="h-4 w-4 text-slate-700 transition-transform duration-300 ease-out"
        :class="{ 'rotate-180': open }"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>

    <!-- Content wrapper inside same container -->
    <div
      ref="content"
      :style="open ? { maxHeight: contentHeight + 'px' } : { maxHeight: '0px' }"
      class="overflow-hidden transition-all duration-300 ease-in-out mt-0"
    >
      <div class="px-4 py-3 text-sm text-slate-700 leading-relaxed">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from "vue";
export default {
  name: "expanderStep",
  props: {
    step: { type: String, default: "02" },
    icon: { type: String, default: "🧑‍💻" },
    title: { type: String, default: "Frontend Environment" },
    background: { type: String, default: "bg-indigo-100" },
    style: { type: String, default: "border-indigo-900 bg-indigo-200/40 hover:bg-indigo-700/30" },
  },
  setup() {
    const open = ref(false);
    const content = ref(null);
    const contentHeight = ref(0);

    const measure = () => {
      if (content.value) {
        contentHeight.value = content.value.scrollHeight;
      }
    };

    const toggle = () => {
      open.value = !open.value;
      nextTick(measure);
    };

    return { open, content, contentHeight, toggle, measure };
  },
  mounted() {
    nextTick(() => {
      this.measure();
    });
  },
};
</script>
